import {actions as A} from '../constants/actions';

const defaultState = {
  showProgressBarPopUp: false,
  message: '',
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SHOW_PROGRESS_BAR_POP_UP:
      const {message} = payload;
      return {...state, showProgressBarPopUp: true, message};

    case A.HIDE_PROGRESS_BAR_POP_UP:
      return {...state, showProgressBarPopUp: false, message: ''};

    default:
      return state;
  }
}
